import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CodemirrorComponent } from 'ng2-codemirror';

@Component({
	selector: 'app-service-scheduler-task-history',
	templateUrl: './history.component.html',
	styleUrls: ['./history.component.css']
})
export class SchedulerHistoryComponent implements OnInit {

	_taskHistory: any;
	@Input() set taskHistory(_taskHistory: any) {
		this._taskHistory = _taskHistory;
		if (_taskHistory) {
			if (_taskHistory.apiPayload) {
				_taskHistory.apiPayload = JSON.stringify(JSON.parse(_taskHistory.apiPayload), null, 2);

				if (this.apiBody) {
					const that = this;
					setTimeout(() => {
						that.apiBody.instance.refresh();
					}, 1000);
				}
			}
			if (_taskHistory.resultBody) {
				_taskHistory.resultBody = JSON.stringify(JSON.parse(_taskHistory.resultBody), null, 2);
				if (this.resultBody) {
					const that = this;
					setTimeout(() => {
						that.resultBody.instance.refresh();
					}, 1000);
				}
			}
		}
	}
	get taskHistory() {
		return this._taskHistory;
	}

	@Output() close = new EventEmitter<any>();
	
	apiMethods = environment.content.apiMethods;

	apiBodyConfig = {
		lineNumbers: true,
		mode: 'application/json',
		json: true,
		readOnly: true,
		className: "read-only"
	};
	resultBodyConfig = {
		lineNumbers: true,
		mode: 'application/json',
		json: true,
		readOnly: true,
		className: "read-only"
	};
	@ViewChild('apiBody', {static: true}) apiBody: CodemirrorComponent;
	@ViewChild('resultBody', {static: true}) resultBody: CodemirrorComponent;
	
	constructor() { }

	ngOnInit() {
	}

	toJson(jsonString: string): any {
		try {
			return JSON.stringify(JSON.parse(jsonString), null, 2);
		} catch(error) {
			return jsonString;
		}
	}

	doClose() {
		this.close.emit(this.taskHistory);
	}

}
